<body [ngClass]="{'green': isLoginPage === true}">
  <router-outlet></router-outlet>
</body>